import { Concurrency, HowItWorks, Root, WhoWeAre, CustomFooter } from "./styles";
import useDocumentTitle from "../../utils/useDocumentTitle";
import HeaderLanding from "../../components/HeaderLanding";
import { FormDemo } from './Form';
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { MutantApiService } from "../../services/MutantApiService";
import store from "../../../app/store/store";
export const Home = () => {
	useDocumentTitle("Blackbolt - Home");
	const [info, setInfo] = useState({});
	const api = new MutantApiService();
	const history = useHistory();
	const user = store.getState().auth?.user;

	useEffect(() => {
		let maintenanceIntervalId;
		let settingsIntervalId;
   
		const fetchMaintenanceData = async () => {
				try {
						const maintenanceData = await api.makeHttpRequest({
								url: `/maintenance`,
								method: "GET"
						});
						setInfo(maintenanceData);
				} catch (error) {
						console.error('Erro ao buscar dados de manutenção', error);
				}
		};

		const checkMaintenanceMode = async () => {
				try {
						const settings = await api.makeHttpRequest({
								url: `/settings`,
								method: "GET"
						});

						if (settings.maintenanceMode && !user?.role === 'ADMIN') {
								history.push('/maintenance');
						}
				} catch (error) {
						console.error('Erro ao verificar o modo de manutenção', error);
				}
		};

		fetchMaintenanceData();
		checkMaintenanceMode();

		maintenanceIntervalId = setInterval(fetchMaintenanceData, 300000);
		settingsIntervalId = setInterval(checkMaintenanceMode, 300000);

		return () => {
				clearInterval(maintenanceIntervalId);
				clearInterval(settingsIntervalId);
		};
}, []);
	return (
		<Root>
			<HeaderLanding />
			<FormDemo />
			<HowItWorks id="section2">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h1>Os sintetizadores de voz atual, para português brasileiro, não reproduzem a voz humana com naturalidade.</h1>
							<h6>Isso se dá pelo fato de que não há um tratamento prosódico, entoacional e expressivo na construção destas plataformas. No
								entanto, para quem utiliza interfaces de voz (URA, VDA, Bots, Personas Virtuais, Assistente Pessoal), é fundamental um
								sintetizador que exprima um efeito de naturalidade, pois esta capacidade engaja usuários, consumidores e aumenta a taxa de
								sucesso.</h6>
						</div>
					</div>

					<div className="row mgT60">
						<div className="col-md-8">
							<h3><span>O BlackBolt</span></h3>
							<p>O desafio principal do Blackbolt parte do fato de que os textos escritos são bem
								menos complexos e completos do que os textos falados, ou seja, a escrita é
								um meio limitado de comunicação, já que não é capaz de transmitir
								informações prosódicas, cadenciais e expressivas.
								Deste modo, um TTS convencional simplesmente converte o texto escrito para
								o meio oral, ignorando toda uma gama de determinantes decisivos para que o
								enunciado soe natural, como o de qualquer pessoa no dia-a-dia.
								Assim, o Blackbolt não deseja ser um simples TTS, mas um locutor virtual, pois
								com tal inovação, será possível adequar as vocalizações às intenções originais
								da enunciação, imprimindo assim efeitos de acolhimento, marcas discursivas,
								simpatia, ênfase, rigidez, entre muitos outros artifícios, além, é claro, do
								tratamento prosódico, que garante com as curvas entoacionais naturais que as
								sentenças soem como diálogos humanos reais.
								Para o empreendimento de criar este sistema gerador de voz, os designers,
								linguistas e desenvolvedores precisam gerar uma quantidade extremamente grande de textos e áudios, que são utilizados de forma comparada no
								aprendizado da máquina.</p>
						</div>
						<div className="col-md-4">
							<img src="/images/icons/robot.svg" alt="" className="robot" />
						</div>
					</div>
				</div>
			</HowItWorks>

			<Concurrency>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h3>Amostra de áudios</h3>
						</div>
					</div>
					<div className="row">
						<div className="col-md-12">
							<table className="table table-borderless table-responsive">
								<thead>
									<tr>
										<th scope="col" className="custom-th" />
										<th scope="col">
											<img src="/images/logo.png" alt="" className="img-fluid logo-blackbolt" />
										</th>
										<th scope="col">
											<img src="/images/logo-google-cloud.png" title="Google Text To Speech" alt="" className="img-fluid google-cloud" />
										</th>
										<th scope="col">
											<img src="/images/logo-amazon-polly.png" title="Amazon Polly" alt="" className="img-fluid amazon-polly" />
										</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<th scope="col">Oi. Você fala algum idioma estrangeiro? Somente um idioma nunca é bastante.</th>
										<td>
											<audio controls>
												<source src="/audios/exemplo1-155mil.wav" type="audio/mpeg" />
											</audio>
										</td>
										<td>
											<audio controls>
												<source src="/audios/google1.mp3" type="audio/mpeg" />
											</audio>
										</td>
										<td>
											<audio controls>
												<source src="/audios/polly1.mp3" type="audio/mpeg" />
											</audio>
										</td>
									</tr>
									<tr>
										<th scope="col">Síntese de fala é o processo de produção artificial de fala humana. Um sistema informático utilizado para este propósito é denominado sintetizador de fala, e pode ser implementado em software ou hardware.</th>
										<td className="custom-audio">
											<audio controls>
												<source src="/audios/exemplo2-155mil.wav" type="audio/mpeg" />
											</audio>
										</td>
										<td className="custom-audio">
											<audio controls>
												<source src="/audios/google2.mp3" type="audio/mpeg" />
											</audio>
										</td>
										<td className="custom-audio">
											<audio controls>
												<source src="/audios/polly2.mp3" type="audio/mpeg" />
											</audio>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</Concurrency>

			<WhoWeAre id="section3">
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<img src="/images/logo-mutant.png" alt="" className="logo-mutant" />
							<h1>Somos especialistas em <span>Customer Experience</span> em plataformas digitais</h1>
							<a href="https://mutantbr.com/" target="_blank">Saiba mais</a>
						</div>
					</div>
				</div>
			</WhoWeAre>

			<CustomFooter>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<img src="/images/logo-white.png" alt="" className="logo-white" />
							<h6>Ajude-nos a encontrar outros doadores de voz!</h6>
							<ul>
								<li>
									<a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.facebook.com%2FMutantOficial%2F&amp;src=sdkpreparse" target="_blank">
										<img src="/images/icons/facebook-white.svg" alt="" />
									</a>
								</li>
								<li>
									<a href="https://www.linkedin.com/shareArticle?mini=true&url=https://www.linkedin.com/company/mutantbr&title=BlackBolt&summary=Ajude-nos a encontrar outros doadores de voz!&source=http://www.blackbolt.com.br" target="_blank">
										<img src="/images/icons/linkedin-white.svg" alt="" />
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="row">
						<div className="col-6">
							<p>© {(new Date()).getFullYear()} Mutant Br</p>
						</div>
						<div className="col-6">
							<p className="text-right">All Right Reserverd</p>
						</div>
					</div>
				</div>
			</CustomFooter>
		</Root>
	)
}

export default Home;